import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import RouteMetadata from './components/RouteMetadata';
import NotificationBar from './components/NotificationBar';
import Navigation from './components/Navigation';
import GoogleAnalytics from './components/GoogleAnalytics';
import SkipToMainLink from './components/SkipToMainLink';
import LandingPage from './pages/LandingPage';
import OurServices from './pages/OurServices';
import Research from './pages/Research';
import OurTeam from './pages/OurTeam';
import ContactUs from './pages/ContactUs';
import WaitlistForm from './pages/WaitlistForm';
import LocationSEO from './pages/LocationSEO';
import ReferralsPage from './pages/ReferralsPage';
import NotFound from './pages/NotFound';
import LocationPage from './pages/LocationPage';
import SecretSpot from './pages/SecretSpot';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Blog from './pages/Blog';
import BlogArticle from './pages/BlogArticle';
import ServicePage from './pages/ServicePage';

// Component to handle scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Always scroll to top on route change immediately
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export function SiteContent() {
  return (
    <>
      <RouteMetadata />
      <GoogleAnalytics />
      <ScrollToTop />
      <div className="min-h-screen bg-white pb-0">
        <SkipToMainLink />
        <NotificationBar />
        <Navigation />
        <main id="main-content" tabIndex={-1} className="outline-none">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/services" element={<OurServices />} />
            <Route path="/research" element={<Research />} />
            <Route path="/team" element={<OurTeam />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/book" element={<WaitlistForm />} />
            <Route path="/south-florida-pet-dental" element={<LocationSEO />} />
            <Route path="/referrals" element={<ReferralsPage />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogArticle />} />
            <Route path="/services/:serviceId" element={<ServicePage />} />
            <Route path="/locations/:cityId" element={<LocationPage />} />
            {/* The game remains accessible but excluded from search. */}
            <Route path="/spot" element={<SecretSpot />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/terms-and-conditions" element={<Navigate to="/terms-of-service" replace />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
      </div>
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <SiteContent />
      </Router>
    </HelmetProvider>
  );
}

export default App;
